export enum OKRCategories {
    None = '', // Empty Category is used when scenario action does not map to a OKR category.
    Seen = 'Seen',
    Closed = 'Closed',
    Tried = 'Tried', // Used when action triggers LLM directly
    TriedInitiate = 'Tried_Initiate', // Used when action triggers bizchat, which in turn triggers LLM. Introduced Oct 2025.
    TriedResponse = 'Tried_Response',
    Kept = 'Kept',
    ThumbsUp = 'ThumbsUp',
    ThumbsDown = 'ThumbsDown',
    Discard = 'None',
    Analysis = 'Analysis',
}
